/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TimeClockMoveBackIcon16Light } from './TimeClockMoveBackIcon16Light';
import { TimeClockMoveBackIcon16Regular } from './TimeClockMoveBackIcon16Regular';
import { TimeClockMoveBackIcon16Solid } from './TimeClockMoveBackIcon16Solid';
import { TimeClockMoveBackIcon20Light } from './TimeClockMoveBackIcon20Light';
import { TimeClockMoveBackIcon20Regular } from './TimeClockMoveBackIcon20Regular';
import { TimeClockMoveBackIcon20Solid } from './TimeClockMoveBackIcon20Solid';
import { TimeClockMoveBackIcon24Regular } from './TimeClockMoveBackIcon24Regular';
import { TimeClockMoveBackIcon24Solid } from './TimeClockMoveBackIcon24Solid';
import { TimeClockMoveBackIcon32Regular } from './TimeClockMoveBackIcon32Regular';
import { TimeClockMoveBackIcon64Regular } from './TimeClockMoveBackIcon64Regular';
var sizes = {
    16: {
        light: TimeClockMoveBackIcon16Light,
        regular: TimeClockMoveBackIcon16Regular,
        solid: TimeClockMoveBackIcon16Solid,
    },
    20: {
        light: TimeClockMoveBackIcon20Light,
        regular: TimeClockMoveBackIcon20Regular,
        solid: TimeClockMoveBackIcon20Solid,
    },
    24: {
        regular: TimeClockMoveBackIcon24Regular,
        solid: TimeClockMoveBackIcon24Solid,
    },
    32: {
        regular: TimeClockMoveBackIcon32Regular,
    },
    64: {
        regular: TimeClockMoveBackIcon64Regular,
    },
};
export var TimeClockMoveBackIcon = forwardRef('TimeClockMoveBackIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
